import React, { useEffect } from 'react';
import { HeroSection, ApkDropHero, VideoSection } from '.';
import { StepsSection, Testimonials, TargetAudience } from '../../components/home-sections';
import { trackPageView } from '../../services/analyticsService';
import './HomePage.css';

const HomePage = () => {
  useEffect(() => {
    // Track page view 
    trackPageView('Home Page');
  }, []);

  return (
    <div className="home-page">
      <HeroSection />
      <ApkDropHero />
      <StepsSection />
      <VideoSection />
      <Testimonials />
      <TargetAudience />
    </div>
  );
};

export default HomePage; 